import { EventRegistrationForm } from 'system/components/event-registration/form';

export const transformEventRegistrationRequest = (values: EventRegistrationForm): RequestReturn => {
  return {
    codiceSottoscrittore: values?.subscriberCode
      ? Number.parseInt(values?.subscriberCode)
      : undefined,
    codiceTipoEvento: values?.eventCode || undefined,
    codiceTipoDestinazione: values?.destinationCode
      ? Number.parseInt(values?.destinationCode)
      : undefined,
    httpMethod: values?.httpMethod || undefined,
    pathSpecificoConsumer: values?.pathConsumer || undefined,
    progressivo: values?.progressive ? Number.parseInt(values?.progressive) : undefined,
    microservizioConsumer: values?.microConsumer || undefined,
  };
};

interface RequestReturn {
  codiceSottoscrittore?: number;
  codiceTipoEvento?: string;
  codiceTipoDestinazione?: number;
  microservizioConsumer?: string;
  progressivo?: number;
  pathSpecificoConsumer?: string;
  httpMethod?: string;
}
